enum ETipoVeiculo {
  CARRETA = 'CARRETA',
  CAVALO = 'CAVALO',
}

export default ETipoVeiculo
